export const persistedStoragePrefix = '@persisted-storage';

export const PersistedStorageActionTypes = {
  SET_THEME: `${persistedStoragePrefix}/SET_THEME`,
  SET_THEME_TONE: `${persistedStoragePrefix}/SET_THEME_TONE`,
  SET_SELECTED_COMPANY_ID: `${persistedStoragePrefix}/SET_SELECTED_COMPANY_ID`,
};
